// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c4a0382f657e03e3","5285":"c45d5a2a952b0f5c"}[chunkId] + ".css";
};